// 平台与游玩区域硬编码配置（按需求写死，不从后端读取）
export const PLATFORMS = [
  '天航平台',
  '瑶光平台',
  '梦舟平台',
  '揽月平台',
  '火箭之眼'
]

export const PLATFORM_AREAS = {
  '天航平台': ['日塔四层', '月塔三层', '月塔四层', '日塔VIP包厢'],
  '瑶光平台': ['瑶光通用平台'],
  '梦舟平台': ['梦舟平台'],
  '揽月平台': ['普通席', 'VIP嘉宾席', 'VIP贵宾席', '高台区'],
  '火箭之眼': ['火箭之眼通用平台']
}

// 移除 '免票'，免票由系统逻辑处理，不作为可选票种展示
export const TICKET_TYPES = ['成人票', '儿童票', '通用票']

// 若将来需要调整年龄策略，也可以在此处扩展
export default {
  PLATFORMS,
  PLATFORM_AREAS
}


